import { viewSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const saveBulkFulfillmentView = {
  name: "saveBulkFulfillmentView" as const,
  input: z.object({ view: viewSchemas["bulk-fulfillments"] }),
  output: z.object({}),
};
